// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  align-items: center;
  justify-content: center;

  .page-count-item {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: center;
  }

  .page-list {
    display: flex;
    justify-content: center;
    width: 100%;
    gap: 2px;
  }

  .page-item {
    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
    width: 56px;
    height: 48px;
    border: none;
    background-color: var(--tab-filter-off-surface);

    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: var(--text-primary);
    white-space: nowrap;

    cursor: pointer;

    &:hover {
      background: var(--color-brand-hover2);
    }

    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  .page-item.selected {
    background-color: var(--color-brand);
    color: var(--text-invert);
    font-weight: 700;
    opacity: 1;
  }

  .page-item.prev,
  .page-item.next {
    svg > path {
      fill: var(--text-primary);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 1;
      svg > path {
        fill: var(--text-disable);
      }
    }
  }

  .page-item.no-border.disabled {
    cursor: auto;
    opacity: 1;

    svg {
      width: 18px;
      height: 18px;

      path {
        fill: var(--text-primary);
      }
    }
  }
}

.pagination-background {
  background-color: var(--row-dark);
  width: -webkit-fill-available;

  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 24px;
  padding-right: 24px;
}

@container (min-width: 1200px) {
  .pagination {
    justify-content: flex-end;
  }

  .pagination-background {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Pagination/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+CAA+C;;IAE/C,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;;IAEnB,eAAe;;IAEf;MACE,qCAAqC;IACvC;;IAEA;MACE,2BAA2B;MAC3B,8BAA8B;IAChC;;IAEA;MACE,4BAA4B;MAC5B,+BAA+B;IACjC;EACF;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;;IAEE;MACE,yBAAyB;IAC3B;;IAEA;MACE,mBAAmB;MACnB,UAAU;MACV;QACE,yBAAyB;MAC3B;IACF;EACF;;EAEA;IACE,YAAY;IACZ,UAAU;;IAEV;MACE,WAAW;MACX,YAAY;;MAEZ;QACE,yBAAyB;MAC3B;IACF;EACF;AACF;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;;EAE7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .page-count-item {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 14px;\n    text-align: center;\n  }\n\n  .page-list {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    gap: 2px;\n  }\n\n  .page-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    box-sizing: border-box;\n    width: 56px;\n    height: 48px;\n    border: none;\n    background-color: var(--tab-filter-off-surface);\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 100%;\n    color: var(--text-primary);\n    white-space: nowrap;\n\n    cursor: pointer;\n\n    &:hover {\n      background: var(--color-brand-hover2);\n    }\n\n    &:first-child {\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  }\n\n  .page-item.selected {\n    background-color: var(--color-brand);\n    color: var(--text-invert);\n    font-weight: 700;\n    opacity: 1;\n  }\n\n  .page-item.prev,\n  .page-item.next {\n    svg > path {\n      fill: var(--text-primary);\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n      opacity: 1;\n      svg > path {\n        fill: var(--text-disable);\n      }\n    }\n  }\n\n  .page-item.no-border.disabled {\n    cursor: auto;\n    opacity: 1;\n\n    svg {\n      width: 18px;\n      height: 18px;\n\n      path {\n        fill: var(--text-primary);\n      }\n    }\n  }\n}\n\n.pagination-background {\n  background-color: var(--row-dark);\n  width: -webkit-fill-available;\n\n  padding-top: 32px;\n  padding-bottom: 32px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n@container (min-width: 1200px) {\n  .pagination {\n    justify-content: flex-end;\n  }\n\n  .pagination-background {\n    padding-top: 32px;\n    padding-bottom: 32px;\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
